<div
  class="badge"
  [ngClass]="['badge--' + color, 'badge--' + size]"
  [class.badge--margins]="!disableMargins"
  [class.badge--capitalize]="capitalize"
>
  <ng-content></ng-content>
</div>
